import React from 'react';
import PropTypes from 'prop-types';
import Card from '@welldev-group/rcl-card';
import Icon from '@welldev-group/rcl-icon';
import { I18nText } from '@welldev-group/react-comp-lib';
import WorkspaceTableRow from './WorkspaceTableRow';
import WorkspaceTableEditRow from './WorkspaceTableEditRow';
import WorkspaceTableDeleteRow from './WorkspaceTableDeleteRow';

const WorkspaceTable = ({
  affiliateId,
  workspaces,
  updateWorkspace,
  modifyWorkspaces,
  fetchWorkspaces,
  deleteWorkspace,
  rowActionDisabled,
}) => {
  const toggleDeletable = (index, value) => {
    const modifiedWorkspace = [...workspaces];
    modifiedWorkspace[index].deletable = value;
    modifyWorkspaces(modifiedWorkspace, affiliateId);
  };

  const toggleEditable = (index, value) => {
    const modifiedWorkspace = [...workspaces];
    modifiedWorkspace[index].editable = value;
    modifyWorkspaces(modifiedWorkspace, affiliateId);
  };

  const renderRow = (workspace, index) => {
    let content;
    content = (
      <WorkspaceTableRow
        workspace={workspace}
        index={index}
        toggleDeletable={toggleDeletable}
        toggleEditable={toggleEditable}
        actionDisabled={rowActionDisabled}
      />
    );
    if (workspace.editable) {
      content = (
        <WorkspaceTableEditRow
          affiliateId={affiliateId}
          workspace={workspace}
          index={index}
          toggleEditable={toggleEditable}
          updateWorkspace={updateWorkspace}
          fetchWorkspaces={fetchWorkspaces}
        />
      );
      return content;
    }
    if (workspace.deletable) {
      content = (
        <WorkspaceTableDeleteRow
          affiliateId={affiliateId}
          workspace={workspace}
          index={index}
          toggleDeletable={toggleDeletable}
          deleteWorkspace={deleteWorkspace}
          fetchWorkspaces={fetchWorkspaces}
        />
      );
      return content;
    }
    return content;
  };

  return (
    <div className="workspace-table">
      {workspaces.length > 0 ? (
        workspaces.map((workspace, index) => (
          <div className="workspace-table__row" key={workspace.identifier}>
            {renderRow(workspace, index)}
          </div>
        ))
      ) : (
        <Card version="v2" className="workspace-card workspace-card--empty">
          <div className="workspace-card-icon">
            <Icon name="widgets" />
          </div>
          <div className="workspace-card-text">
            <I18nText id="workspace.card.empty.text" />
          </div>
        </Card>
      )}
    </div>
  );
};

WorkspaceTable.defaultProps = {
  rowActionDisabled: false,
};

WorkspaceTable.propTypes = {
  workspaces: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
      identifier: PropTypes.string.isRequired,
      agentUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
  affiliateId: PropTypes.number.isRequired,
  updateWorkspace: PropTypes.func.isRequired,
  modifyWorkspaces: PropTypes.func.isRequired,
  fetchWorkspaces: PropTypes.func.isRequired,
  deleteWorkspace: PropTypes.bool.isRequired,
  rowActionDisabled: PropTypes.bool,
};

export default WorkspaceTable;
